const events = {
  DESTROY_REQUEST: 'component_destroy_request',
};

export default events;



// WEBPACK FOOTER //
// ./resources/assets/js/components/events.js